module.exports = __webpack_public_path__ + "cart-feature-shipping/cart-feature-shipping-05058a42a86c9cf910888f6a5bdc032c.png";